export default __webpack_public_path__ + "static/media/gravity.08fe065e.png";